<div class="component">
    <div class="left-bar">
        <div class="entry adder" (click)="addUser()">
            <mat-icon class="icon">add</mat-icon>
            <span class="text">Nutzer registrieren</span>
        </div>
        <div *ngFor="let user of users">
            <div *ngIf="userPointer == user.id; else unselected" class="entry selected saved" (click)="setUser(user)">
                <div *ngIf="user != null">
                    <img *ngIf="user.profilePicture != null; else noImage" class="preview-image" src="{{getProfilePictureDataForUser(user)}}">
                    <ng-template #noImage>
                        <div class="image-placeholder"></div>
                    </ng-template>
                    <span *ngIf="!isEmpty(user.userName); else noUserName">
                        {{ user.userName }}
                    </span>
                    <ng-template #noUserName>
                        <span class="no-value">
                            Kein Nutzername
                        </span>
                    </ng-template>
                </div>
            </div>
            <ng-template #unselected>
                <div class="entry saved" (click)="setUser(user)">
                    <div *ngIf="user != null">
                        <img *ngIf="user.profilePicture != null; else noImage" class="preview-image" src="{{getProfilePictureDataForUser(user)}}">
                        <ng-template #noImage>
                            <div class="image-placeholder"></div>
                        </ng-template>
                        <span *ngIf="!isEmpty(user.userName); else noUserName">
                            {{ user.userName }}
                        </span>
                        <ng-template #noUserName>
                            <span class="no-value">
                                Kein Nutzername
                            </span>
                        </ng-template>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
    <div class="right-bar">
        <div *ngIf="userPointer != null && this.currentUser != null; else noUser" class="user-edit-view">
            <div class="banner">
                <img *ngIf="hasBannerPicture()" class="image-inner" src="{{bannerPictureData}}">
                <div class="image-control">
                    <mat-icon 
                        class="photo-chooser small primary" 
                        (click)="bannerPicture.click()"
                        matTooltip="Wählen Sie ein Banner mit einer Größe von weniger als einem MB"
                    >
                        add_a_photo
                    </mat-icon>
                    <mat-icon 
                        *ngIf="hasBannerPicture()"
                        class="photo-chooser small danger" 
                        (click)="removeBannerPicture()"
                        matTooltip="Entfernen Sie das aktuelle Bild"
                    >
                        delete_forever
                    </mat-icon>
                </div>
            </div>
            <div class="userimage-parent">
                <div class="userimage">
                    <div *ngIf="hasProfilePicture()" class="image-outer">
                        <img class="image-inner" src="{{profilePictureData}}">
                    </div>
                    <div class="image-control">
                        <mat-icon
                            class="photo-chooser primary" 
                            (click)="profilePicture.click()"
                            matTooltip="Wählen Sie ein quadratisches Profilbild mit einer Größe von weniger als einem MB"
                        >
                            add_a_photo
                        </mat-icon>
                        <mat-icon 
                            *ngIf="hasProfilePicture()"
                            class="photo-chooser danger" 
                            (click)="removeProfilePicture()"
                            matTooltip="Entfernen Sie das aktuelle Bild"
                        >
                            delete_forever
                        </mat-icon>
                    </div>
                </div>
            </div>
            <div class="state-label-panel" style="margin-top: 100px;">
                <div *ngIf="currentUser.isNew; else persistedUser" class="state-label unpersisted">
                    Ungespeicherter Nutzer
                </div>
                <ng-template #persistedUser>
                    <div class="state-label created">
                        Angelegt
                    </div>
                    <div class="state-label second">
                        ID {{ userPointer }}
                    </div>
                </ng-template>
                <input class="state-label locked-inp" matInput [matDatepicker]="picker" matTooltip="Enddatum der Sperre" [(ngModel)]="currentUserLockedEnd" style="height: 0px;" />
                <div class="date-preview" matTooltip="Der Nutzer war zuletzt/ist gesperrt bis zum {{currentUserLockedEnd}}" [class.locked]="currentUserIsLocked()" [class.unlocked]="!currentUserIsLocked()">{{ currentUserLockedEnd }}</div>
                <mat-datepicker (startAt)="currentUserLockedEnd" #picker></mat-datepicker>
                <button mat-raised-button (click)="picker.open()" style="margin-right: 5px;">Sperren</button>
                <button *ngIf="currentUserIsLocked()" mat-raised-button (click)="unlockUser()">Entsperren</button>
            </div>
            <form [formGroup]="form">
                <mat-form-field class="form-field">
                    <input
                        matInput 
                        placeholder="Benutzername"
                        formControlName="userName"
                    />
                </mat-form-field>
                <div *ngIf="userName.touched && userName.errors != null && userName.errors.required" class="alert alert-danger">
                    Sie müssen einen Nutzernamen angeben.
                </div>
                <div *ngIf="userNameIsReservated()" class="alert alert-danger">
                    Dieser Benutzername ist bereits vergeben.
                </div>
                <mat-form-field class="form-field">
                    <input
                        matInput 
                        placeholder="Initialien"
                        formControlName="initials"
                    />
                </mat-form-field>
                <div *ngIf="initials.touched && initials.errors != null && initials.errors.maxlength" class="alert alert-danger">
                    Initialien dürfen maximal 3 Zeichen enthalten.
                </div>
                <div formGroupName="passwords">
                    <mat-form-field class="form-field">
                        <input
                            id="password"
                            matInput 
                            placeholder={{pwPH}}
                            formControlName="password"
                            type="password"
                        />
                    </mat-form-field>
                    <div *ngIf="password.touched && password.errors != null && password.errors.required" class="alert alert-danger">
                        Sie müssen ein Passwort vergeben.
                    </div>
                    <div *ngIf="password.touched && password.errors != null && password.errors.minlength" class="alert alert-danger">
                        Das Passwort muss mindestens 8 Zeichen enthalten.
                    </div>
                    <mat-form-field class="form-field">
                        <input
                            id="confirmPassword"
                            matInput 
                            placeholder={{repeatPwPH}}
                            formControlName="confirmPassword"
                            type="password"
                        />
                    </mat-form-field>
                    <div *ngIf="confirmPassword.touched && confirmPassword.errors != null && confirmPassword.errors.required" class="alert alert-danger">
                        Sie müssen das Passwort wiederholen.
                    </div>
                    <div *ngIf="!passwordMatch()" class="alert alert-danger">
                        Die Passwörter stimmen nicht überein.
                    </div>
                </div>
                <mat-form-field class="form-field">
                    <input
                        matInput 
                        placeholder="E-Mail Adresse"
                        formControlName="email"
                    />
                </mat-form-field>
                <div *ngIf="email.touched && email.errors != null && email.errors.email" class="alert alert-danger">
                    Unzulässige E-Mail angegeben.
                </div>
                <mat-form-field class="form-field">
                    <mat-label>
                        Nutzer Rollen zuweisen
                    </mat-label>
                    <mat-select
                        formControlName="roles"
                        multiple
                    >
                        <mat-option *ngFor="let r of roles" [value]="r.id">
                            {{ r.name }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>
            </form>
            <div class="signature-field">
                <div class="spacer"></div>
                <div *ngIf="signatures.length == 0; else hasSignature" class="no-signatures-hint" (click)="createSignature()">
                    Dieser Nutzer hat keine Unterschrift(en) hinterlegt. Klicken Sie hier um eine Unterschrift anzulegen.
                </div>
                <ng-template #hasSignature>
                    <img class="image-inner" src="{{currentSignaturePictureData}}">
                </ng-template>
                <div class="spacer"></div>
            </div>
            <div *ngIf="signatures.length > 0" class="signature-picture-control">
                <div class="spacer"></div>
                <mat-icon *ngIf="signaturePictureIndex > 0" (click)="signaturePictureIndex=signaturePictureIndex-1">keyboard_arrow_left</mat-icon>
                <mat-icon class="delete" (click)="deleteCurrentSignature()">delete_forever</mat-icon>
                <mat-icon class="create" (click)="createSignature()">add</mat-icon>
                <mat-icon *ngIf="signaturePictureIndex < signatures.length-1" (click)="signaturePictureIndex=signaturePictureIndex+1">keyboard_arrow_right</mat-icon>
                <div class="spacer"></div>
            </div>
            <div class="control-bar">
                <mat-icon
                    *ngIf="userIsValid(); else cannotSave"
                    matTooltip="Änderungen speichern"
                    class="icon success" 
                    (click)="saveUser()"
                >done</mat-icon>
                <ng-template #cannotSave>
                    <mat-icon
                    matTooltip="Kann nicht gespeichert werden"
                    class="icon disabled" 
                >block</mat-icon>
                </ng-template>
                <mat-icon
                    *ngIf="canDeleteUser()" 
                    matTooltip="Nutzer löschen"
                    class="icon danger" 
                    (click)="deleteUser()"
                >delete_forever</mat-icon>
            </div>
        </div>
        <ng-template #noUser>
            <div class="centered-label">
                <mat-icon class="no-selection-icon">
                    person
                </mat-icon>
                <div class="no-selection-headline">
                    Kein Nutzer ausgewählt
                </div>
                <div class="no-selection-subtitle">
                    Legen Sie einen neuen Nutzer an oder wählen Sie einen aus um diesen zu bearbeiten oder zu löschen.
                </div>
            </div>
        </ng-template>
    </div>
</div>
<input #profilePicture type="file" accept="image/*" style="display: none;" (change)="setProfilePicture($event.target.files)" />
<input #bannerPicture type="file" accept="image/*" style="display: none;" (change)="setBannerPicture($event.target.files)" />